export function getRelativeTime(backendTimestamp) {
    if (!backendTimestamp) return null;

    const backendDate = new Date(backendTimestamp);
    const diffMs = Date.now() - backendDate.getTime();

    if (isNaN(diffMs) || diffMs < 0) return "just now";

    const secs = Math.floor(diffMs / 1000);
    const mins = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (secs < 60) return "just now";
    if (mins < 60) return `${mins} min ago`;

    if (hours < 24) {
        const remMins = mins % 60;
        return remMins > 0
            ? `${hours} hr ${remMins} min ago`
            : `${hours} hr ago`;
    }

    if (days < 7) {
        const remHours = hours % 24;
        return remHours > 0
            ? `${days} day ${remHours} hr ago`
            : `${days} day ago`;
    }

    if (weeks < 4) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
    return `${years} year${years > 1 ? "s" : ""} ago`;
}